import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { API_GET } from "../../helpers/api";
import * as actions from "../actions/reconciliation";
import {
  GET_RECONCILIATION_INFO_REQUEST,
  GET_RECONCILIATION_LIST_REQUEST,
  GET_SELECTED_RECONCILIATION_DETAILS_REQUEST,
  GET_SELECTED_RECONCILIATION_ITEM_DETAILS_REQUEST,
} from "../types";

// RECONCILIATION INFO SAGA
function* watchGetReconciliationInfo() {
  yield takeEvery(GET_RECONCILIATION_INFO_REQUEST, getReconciliationInfo);
}

function* getReconciliationInfo(action) {
  try {
    const res = yield call(apiGetReconciliationInfo, action.payload);
    yield put(actions.getReconciliationInfoSucceeded({ ...res.data }));
  } catch (err) {
    yield put(actions.getReconciliationInfoFailed());
  }
}

const apiGetReconciliationInfo = (term) =>
  API_GET("reconciliation/info", {
    term,
  });

// RECONCILIATION LIST SAGA
function* watchGetReconciliationList() {
  yield takeEvery(GET_RECONCILIATION_LIST_REQUEST, getReconciliationList);
}

function* getReconciliationList(action) {
  try {
    const res = yield call(apiGetReconciliationList, action.payload);

    yield put(actions.getReconciliationListSucceeded(res.data));
  } catch (err) {
    yield put(actions.getReconciliationListFailed());
  }
}

const apiGetReconciliationList = (reqParams) => {
  return API_GET("reconciliation/report-with-pagination", {
    ...reqParams,
    page: reqParams.page || 0,
    size: 10,
  });
};
// SELECTED RECONCILIATION DETAILS SAGA
function* watchGetSelectedReconciliationDetails() {
  yield takeEvery(
    GET_SELECTED_RECONCILIATION_DETAILS_REQUEST,
    getSelectedReconciliationDetails
  );
}

function* getSelectedReconciliationDetails(action) {
  const { organizationId, term, operation } = action.payload;
  try {
    const res = yield call(
      apiGetSelectedReconciliationDetails,
      organizationId,
      term,
      operation
    );
    var totalDebit = 0;
    var totalCredit = 0;
    var totalDebitWithWat = 0;
    var totalCreditWithWat = 0;
    var totalCreditAll = 0;
    var totalDebitAll = 0;
    var subTotals = {};
    res.data?.reconciliationList.forEach((element) => {
      totalDebit = totalDebit + element.totalDebit;
      totalCredit = totalCredit + element.totalCredit;
      totalDebitWithWat =
        totalDebitWithWat + element.totalDebitWithWat - element.totalDebit;
      totalCreditWithWat =
        totalCreditWithWat + element.totalCreditWithWat - element.totalCredit;
      totalCreditAll = totalCreditAll + element.totalCreditWithWat;
      totalDebitAll = totalDebitAll + element.totalDebitWithWat;

      subTotals = {
        totalDebit: totalDebit.toFixed(2),
        totalCredit: totalCredit.toFixed(2),
        totalDebitWithWat: totalDebitWithWat.toFixed(2),
        totalCreditWithWat: totalCreditWithWat.toFixed(2),
        totalCreditAll: totalCreditAll.toFixed(2),
        totalDebitAll: totalDebitAll.toFixed(2),
      };
    });

    yield put(
      actions.getSelectedReconciliationDetailsSucceeded({
        details: res.data?.reconciliationList,
        subTotals: subTotals,
      })
    );
  } catch (err) {
    yield put(actions.getSelectedReconciliationDetailsFailed());
  }
}

const apiGetSelectedReconciliationDetails = (organizationId, term, operation) =>
  API_GET(`reconciliation/report/${organizationId}`, {
    term,
    operation,
  });

// SELECTED RECONCILIATION ITEM DETAILS SAGA
function* watchGetSelectedReconciliationItemDetails() {
  yield takeEvery(
    GET_SELECTED_RECONCILIATION_ITEM_DETAILS_REQUEST,
    getSelectedReconciliationItemDetails
  );
}

function* getSelectedReconciliationItemDetails(action) {
  const { organizationId, reqParams } = action.payload;
  try {
    const res = yield call(
      apiGetSelectedReconciliationItemDetails,
      organizationId,
      reqParams
    );

    yield put(actions.getSelectedReconciliationItemDetailsSucceeded(res.data));
  } catch (err) {
    yield put(actions.getSelectedReconciliationItemDetailsFailed());
  }
}

const apiGetSelectedReconciliationItemDetails = (organizationId, reqParams) =>
  API_GET(`reconciliation/organization/${organizationId}`, {
    ...reqParams,
    page: 0,
    size: 1000,
  });

export default function* reconciliationSaga() {
  yield all([
    fork(watchGetReconciliationInfo),
    fork(watchGetReconciliationList),
    fork(watchGetSelectedReconciliationDetails),
    fork(watchGetSelectedReconciliationItemDetails),
  ]);
}
